// @flow

import React from 'react';
import KeepeekMedia from '../../../common/KeepeekMedia';
import type { MarketingTemplate } from '../../../../types/marketingType';
import KeepeekMediaCarousel from '../../../common/KeepeekMediaCarousel';

type Props = {
  data: MarketingTemplate
}

function FullContentCarousel({ data }: Props) {
  return (
    <div className="fullcontent-container">
      <div className="title">
        {data.title}
      </div>
      <div className="side-image">
        <KeepeekMedia keepeekId={data.sideImage.keepeekId} />
      </div>
      <div className="description">{data.description}</div>
      <KeepeekMediaCarousel medias={data.medias} />
    </div>
  );
}

export default FullContentCarousel;
